import { render, staticRenderFns } from "./QuillRich.vue?vue&type=template&id=0f879e56"
import script from "./QuillRich.vue?vue&type=script&lang=js"
export * from "./QuillRich.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports